<template>
  <el-main>
    <div class="container">
      <el-breadcrumb separator="/" class="common-nav">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/course' }">选课中心</el-breadcrumb-item>
        <el-breadcrumb-item>{{ course.title }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="course-info">
        <div class="course-images">
          <el-carousel height="270px">
            <el-carousel-item v-for="(item, index) in course.images" :key="index">
              <el-image :src="path + item" fit="cover" class="course-image-item"></el-image>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="course-info-content">
          <div class="course-info-content-title">
            {{ course.title }}
          </div>
          <div class="course-info-content-price">
            <span>价格：</span>
            <span class="price-icon">¥</span>
            <span class="price">{{ course.o_price }}</span>
<!--            <span class="price-old">¥ {{ course.o_price }}</span>-->
            <span class="study-num">已有{{ course.num }}人学习</span>
          </div>
          <div class="course-info-content-tags">
            <div>特色服务：</div>
            <div class="course-info-content-tags-item" v-for="(i, n) in course.labels" :key="n">
              {{ i.title }}
            </div>
          </div>
          <div class="course-info-content-course" v-if="course.subclass && course.subclass.courses.length > 0">
            <div class="course-info-content-course-title">选择科目：</div>
            <div class="course-info-content-course-item" v-for="(item, index) in course.subclass.courses" :key="index"
                 :class="[checkedCourse.findIndex(i => i === item.id) >= 0 ? 'current' : '']" @click="selectCourse(item.id)">
              {{ item.title }}
            </div>
          </div>
          <div class="course-info-content-bottom">
            <div class="course-follow">
              <div class="course-follow-btn" @click="goFollow">
                <i class="course-follow-icon" :class="[follow ? 'el-icon-star-on' : 'el-icon-star-off']"></i>
                <span>{{ follow ? '取消收藏' : '收藏' }}</span>
              </div>
              <span class="course-click">访问量：{{ course.click }}</span>
            </div>
            <div class="course-buy">
              <el-button @click="addCart">加入购物车</el-button>
              <el-button type="primary" @click="addOrder">立即购买</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="course-body">
        <div class="course-body-left">
          <div class="card">
            <div class="card-title">
              课程详情
            </div>
            <div class="card-body">
              <div v-html="course.body" class="course-content"></div>
            </div>
          </div>
        </div>
        <div class="course-body-right">
          <div class="card">
            <div class="card-title">
              热门推荐
            </div>
            <div class="card-body">
              <div class="course-hot">
                <div class="course-hot-item" v-for="(item, index) in hots" :key="index">
                  <a :href="'/course/' + item.id" target="_blank">
                    <div class="course-hot-img">
                      <img :src="item.images && item.images.length > 0 ? path + item.images[0] : noneImg" :alt="item.title"
                           class="course-hot-image">
                    </div>
                    <div class="course-hot-title">
                      {{ item.title }}
                    </div>
                    <div class="course-hot-info">
                      <div class="course-hot-price">¥{{ item.o_price }}</div>
                      <div>{{ item.num }}人购买</div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
import {authRequest, request} from "@/utils/request";
import {mapGetters} from 'vuex'
import ls from "@/utils/localStorage";

export default {
  name: "CourseDetails",
  head() {
    return {
      title: this.course.title ? this.course.title : '课程详情'
    }
  },
  data() {
    return {
      id: 0,
      course: '',
      path: process.env.VUE_APP_FILE,
      hots: [],
      follow: false,
      noneImg: process.env.VUE_APP_NONE,
      checkedCourse: []
    }
  },
  computed: {
    ...mapGetters([
      'isLoggedIn'
    ])
  },
  created() {
    this.id = this.$route.params.id
    this.getCourse()
    this.getHot()
    if (this.isLoggedIn) {
      this.getFollow()
    }
  },
  methods: {
    async getCourse() {
      try {
        let response = await request('course/' + this.id, {
          method: 'GET'
        })
        this.course = response.data.data
      } catch (e) {

      }
    },
    async getHot() {
      try {
        let response = await request('study/hot', {
          method: 'POST'
        })
        this.hots = response.data.data
      } catch (e) {

      }
    },
    async goFollow() {
      if (!this.checkLogin()) {
        return false
      }
      try {
        let response = await authRequest('follow', {
          method: 'POST',
          data: {
            id: this.id
          }
        })
        if (response.data.attached.length > 0) {
          this.$message.success('收藏成功')
          this.follow = true
        }
        if (response.data.detached.length > 0) {
          this.$message.info('已取消收藏')
          this.follow = false
        }
      } catch (e) {

      }
    },
    async getFollow() {
      try {
        let response = await authRequest('user/follow/' + this.id, {
          method: 'GET'
        })
        if (response.data.code === 200) {
          this.follow = true
        }
      } catch (e) {

      }
    },
    async addCart() {
      if (!this.checkLogin()) {
        return false
      }
      if (this.checkedCourse.length <= 0) {
        this.$message.warning('请选择科目')
        return false
      }
      try {
        let response = await authRequest('cart', {
          method: 'POST',
          data: {
            course_id: this.checkedCourse,
            study_id: this.id
          }
        })
        if (response.status === 201) {
          this.$message.success('加入购物车成功')
          this.$router.push({
            name: 'cart'
          })
        }
      } catch (e) {

      }
    },
    addOrder() {
      if (!this.checkLogin()) {
        return false
      }
      if (this.checkedCourse.length <= 0) {
        this.$message.warning('请选择科目')
        return false
      }
      let result = []
      const courses = this.course.subclass.courses
      this.checkedCourse.forEach(item => {
        let index = courses.findIndex(i => i.id === item)
        let course = ''
        if (index >= 0) {
          course = courses[index]
        }
        result.push({
          course_id: item,
          study_id: this.course.id,
          study: this.course,
          course: course
        })
      })
      ls.setItem('order', result)
      this.$router.push({name: 'order'})
    },
    checkLogin() {
      if (!this.isLoggedIn) {
        this.$confirm('您还没有登录，是否前往登录？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          this.$router.push({name: 'login'})
        }).catch(() => {

        });
        return false
      }
      return true
    },
    selectCourse(id) {
      let index = this.checkedCourse.findIndex(item => item === id)
      if (index >= 0) {
        this.checkedCourse.splice(index, 1)
      } else {
        this.checkedCourse.push(id)
      }
    }
  }
}
</script>

<style scoped>
.course-info {
  display: flex;
  justify-content: space-between;
  background-color: #ffffff;
  padding: 15px;
  border-radius: 5px;
}

.course-images {
  width: 480px;
}

.course-image-item {
  height: 270px;
  border-radius: 5px;
}

.course-info-content {
  width: 650px;
  position: relative;
}

.course-info-content-title {
  font-size: 20px;
  color: #333333;
  font-weight: 500;
}

.course-info-content-price {
  height: 60px;
  display: flex;
  align-items: center;
  background-color: #f3f3f3;
  margin-top: 15px;
  padding: 0 15px;
  font-size: 14px;
}

.price-icon {
  font-size: 20px;
  color: #f44848;
}

.price {
  font-size: 32px;
  color: #f44848;
  margin-left: 10px;
  margin-top: -8px;
}

.price-old {
  text-decoration: line-through;
  font-style: italic;
  color: #999999;
  margin-left: 10px;
}

.study-num {
  margin-left: 20px;
}

.course-info-content-tags {
  display: flex;
  flex-wrap: wrap;
  margin-top: 15px;
  font-size: 14px;
}

.course-info-content-tags-item {
  background-color: #2aacb2;
  color: #ffffff;
  margin-right: 5px;
  padding: 0 5px;
  border-radius: 3px;
  margin-bottom: 5px;
}

.course-info-content-bottom {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  color: #6e6e6e;
}

.course-follow {
  font-size: 14px;
  display: flex;
  align-items: center;
}

.course-follow-btn {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.course-follow-icon {
  font-size: 20px;
  color: #2aacb2;
}

.course-click {
  margin-left: 10px;
}

.course-body {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}

.course-body-left {
  width: 870px;
  background-color: #ffffff;
  border-radius: 5px;
  overflow: hidden;
}

.course-body-right {
  width: 300px;
  background-color: #ffffff;
  border-radius: 5px;
  overflow: hidden;
}

.course-hot-item {
  border-bottom: 1px dashed #ebebeb;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.course-hot-image {
  height: 160px;
  width: 100%;
  object-fit: cover;
  border-radius: 5px;
}

.course-hot-title {
  font-size: 14px;
  color: #333333;
}

.course-hot-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #999999;
}

.course-hot-price {
  color: #f44848;
  font-size: 16px;
}

.course-info-content-course {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
}

.course-info-content-course-item {
  padding: 5px 10px;
  border: 1px solid #ebebeb;
  margin-right: 5px;
  font-size: 14px;
  color: #333333;
  border-radius: 3px;
  cursor: pointer;
  margin-bottom: 5px;
}

.course-info-content-course-item.current {
  background-color: #2aacb2;
  color: #ffffff;
  border-color: #2aacb2;
}

.course-info-content-course-title{
  padding: 5px 0;
  font-size: 14px;
}

.course-content>>>img{
  max-width: 100%;
}
</style>
